import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { currentRoles, numbers, services } from '../data/practice';
export function Practice() {
  return <section id="practice" className="border-b border-rule" data-id="element-60" data-mp="18ptz705rqpm9">
      <div className="mx-auto max-w-page px-6 py-20 lg:px-10 lg:py-28" data-id="element-61" data-mp="1dnvfjdbt8au1">
        <div className="grid gap-8 lg:grid-cols-12" data-id="element-62" data-mp="1imgk1oy3hgoa">
          <div className="lg:col-span-4" data-id="element-63" data-mp="1il5d5g9crssy">
            <p className="font-sans text-[12px] uppercase tracking-overline text-muted" data-id="element-64" data-mp="kyok4n7nk1d0">
              The day job
            </p>
            <h2 className="mt-6 font-serif text-[clamp(2rem,4vw,3.25rem)] leading-[1.02] tracking-[-0.02em] text-ink" data-id="element-65" data-mp="py185ba9feh6">
              Advice, not products
            </h2>
          </div>

          <div className="lg:col-span-7 lg:col-start-6" data-id="element-66" data-mp="zo48jwjpnupj">
            <p className="font-sans text-[17px] leading-[1.7] text-ink-soft" data-id="element-67" data-mp="27oq37law1cv">
              I work as a SEBI Registered Investment Advisor and Certified Financial Planner.
              That means I am paid by the client and no one else, and the work is the whole
              picture rather than a single product.
            </p>
            <ul className="mt-8 flex flex-wrap gap-x-3 gap-y-3" data-id="element-68" data-mp="3h691tz3fbcth">
              {services.map(service => <li key={service} className="border border-rule px-3 py-[6px] font-sans text-[13px] text-ink" data-id="element-69" data-mp="3cer19c5bbe91">
                  {service}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-16 grid gap-x-8 gap-y-10 border-t border-rule pt-10 lg:grid-cols-12" data-id="element-70" data-mp="2yfhvl6eqg2jb">
          {currentRoles.map(role => <article key={role.id} className="flex flex-col lg:col-span-6" data-id="element-71" data-mp="2thgc4kdea17b">
              <header data-id="element-72" data-mp="2pgebbz3txh38">
                <h3 className="font-serif text-[26px] leading-none text-ink" data-id="element-73" data-mp="2pgxjwp7lat4l">
                  {role.href ? <a href={role.href} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-4 focus-visible:ring-offset-paper" data-id="element-74" data-mp="rnh2s4ju1tx9">
                      {role.company}
                      <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-75" data-mp="2c6udm7ah5qfx" />
                      <span className="sr-only" data-id="element-76" data-mp="2zxg9l077fk9k">(opens in a new tab)</span>
                    </a> : role.company}
                </h3>
                <p className="mt-3 font-sans text-[14px] font-medium text-ink" data-id="element-77" data-mp="2qws2yqk54m6p">{role.title}</p>
                <p className="mt-1 font-sans text-[13px] tabular-nums text-muted" data-id="element-78" data-mp="2vvctfy9lbrhy">
                  {role.years} · {role.place}
                </p>
              </header>

              <p className="mt-5 font-sans text-[15px] leading-[1.6] text-ink" data-id="element-79" data-mp="1fjfw06t33ngb">{role.summary}</p>

              <ul className="mt-4 space-y-3 border-t border-rule pt-4" data-id="element-80" data-mp="1ked1x4v2hgoz">
                {role.points.map(point => <li key={point.slice(0, 28)} className="font-sans text-[14px] leading-[1.6] text-ink-soft" data-id="element-81" data-mp="17xu5u3qk3kfs">
                    {point}
                  </li>)}
              </ul>
            </article>)}
        </div>

        <div className="mt-16 border-t border-rule pt-8" data-id="element-82" data-mp="t8xsps9n7h8b">
          <p className="font-sans text-[12px] uppercase tracking-overline text-muted" data-id="element-83" data-mp="t9hbtcb14bnx">
            Leading investments at Liquide, 2023 — 2025
          </p>
          <dl className="mt-8 grid grid-cols-2 gap-x-8 gap-y-8 lg:grid-cols-4" data-id="element-84" data-mp="12z98cc2ovev1">
            {numbers.map(item => <div key={item.label} data-id="element-85" data-mp="y6ziew1kqesr">
                <dt className="sr-only" data-id="element-86" data-mp="y5xwtxmxm9ws">{item.label}</dt>
                <dd data-id="element-87" data-mp="ahepbkbpi15r">
                  <span className="block font-serif text-[clamp(2rem,3.5vw,3rem)] leading-none tracking-[-0.02em] text-ink" data-id="element-88" data-mp="agvhiwfrst5g">
                    {item.value}
                  </span>
                  <span className="mt-3 block max-w-[22ch] font-sans text-[13px] leading-[1.5] text-muted" data-id="element-89" data-mp="34ynoar4hazw2">
                    {item.label}
                  </span>
                </dd>
              </div>)}
          </dl>
        </div>
      </div>
    </section>;
}